export default {"src":"/_next/static/media/InComplete.06b4ded7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};